module.exports = __webpack_public_path__ + "img/WLGHZX_4.7e5a8468.jpg";